(function () {
	'use strict';

	if (customElements.get('pdp-faq-accordion')) return;

	class PdpFaqAccordion extends HTMLElement {
		constructor() {
			super();
			this._onClick = this._onClick.bind(this);
			this._onKeydown = this._onKeydown.bind(this);
		}

		connectedCallback() {
			this._toggles = Array.prototype.slice.call(
				this.querySelectorAll('[data-pdp-faq-toggle]')
			);
			this._toggles.forEach((btn) => {
				btn.addEventListener('click', this._onClick);
			});
			this.addEventListener('keydown', this._onKeydown);
		}

		disconnectedCallback() {
			if (!this._toggles) return;
			this._toggles.forEach((btn) => {
				btn.removeEventListener('click', this._onClick);
			});
			this.removeEventListener('keydown', this._onKeydown);
		}

		_onClick(event) {
			const btn = event.currentTarget;
			const isOpen = btn.getAttribute('aria-expanded') === 'true';

			this._toggles.forEach((other) => {
				if (other !== btn) this._setExpanded(other, false);
			});
			this._setExpanded(btn, !isOpen);
		}

		_setExpanded(btn, expanded) {
			btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
			const item = btn.closest('.pdp-faq__item');
			if (item) item.classList.toggle('pdp-faq__item--open', expanded);
		}

		_onKeydown(event) {
			const current = event.target.closest('[data-pdp-faq-toggle]');
			if (!current) return;

			const index = this._toggles.indexOf(current);
			if (index === -1) return;

			const count = this._toggles.length;
			let next = null;

			switch (event.key) {
				case 'ArrowDown':
					next = this._toggles[(index + 1) % count];
					break;
				case 'ArrowUp':
					next = this._toggles[(index - 1 + count) % count];
					break;
				case 'Home':
					next = this._toggles[0];
					break;
				case 'End':
					next = this._toggles[count - 1];
					break;
				default:
					return;
			}

			event.preventDefault();
			next.focus();
		}
	}

	customElements.define('pdp-faq-accordion', PdpFaqAccordion);
})();
